module.exports = __webpack_public_path__ + "static/our-clients2-d2bb2c4002eaf4fe5e6f97ff2e548929.jpg";